import { Fragment } from 'react';
import { Text, TextInput, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { FilterItemRadio, FilterRadioContainer } from '../GenericSubElement/FilterItemRadio';
import {
  RadioTextFilterOperation,
  readableRadioTextOperations,
  ValidationErrorEnum,
} from './GenericRadioTextType';

const InputContainer = styled.div`
  margin-left: ${tokens.spacer.x3};
`;

const ErrorContainer = styled.div`
  margin-top: ${tokens.spacer.x0};
`;

interface GenericRadioTextBodyProps {
  operation?: RadioTextFilterOperation;
  operationOptions: RadioTextFilterOperation[];
  onOperationChange: (newValue: RadioTextFilterOperation) => void;
  stringValue: string;
  onStringChange: (newValue: string) => void;
  placeholders?: Partial<Record<RadioTextFilterOperation, string>>;
  filterName: string;
  validationError?: ValidationErrorEnum;
}

export function GenericRadioTextBody({
  operation,
  onOperationChange,
  stringValue,
  onStringChange,
  operationOptions = [],
  filterName,
  placeholders,
  validationError,
}: GenericRadioTextBodyProps): JSX.Element {
  return (
    <FilterRadioContainer>
      {operationOptions.map((option) => {
        return (
          <Fragment key={option}>
            <FilterItemRadio
              isChecked={option === operation}
              id={`${filterName}-dropdown-${option}`}
              name={option}
              onChange={() => onOperationChange(option)}
              value={`${option}`}
              labelContent={readableRadioTextOperations[option]}
              isInvalid={validationError === ValidationErrorEnum.SELECT_ONE_OPTION}
            />
            {operation === option &&
              operation !== RadioTextFilterOperation.IS_UNKNOWN &&
              operation !== RadioTextFilterOperation.HAS_ANY_VALUE && (
                <InputContainer>
                  <TextInput
                    placeholder={placeholders ? placeholders[option] : ''}
                    value={stringValue}
                    onChange={(e) => onStringChange(e.target.value)}
                    isInvalid={
                      validationError === ValidationErrorEnum.TEXT_TOO_SHORT ||
                      validationError === ValidationErrorEnum.TEXT_EMPTY
                    }
                    size="s"
                  />
                  {(validationError === ValidationErrorEnum.TEXT_TOO_SHORT ||
                    validationError === ValidationErrorEnum.TEXT_EMPTY) && (
                    <ErrorContainer>
                      <Text textColor="text_error">{validationError}</Text>
                    </ErrorContainer>
                  )}
                </InputContainer>
              )}
          </Fragment>
        );
      })}
      {validationError === ValidationErrorEnum.SELECT_ONE_OPTION && (
        <Text textColor="text_error">{validationError}</Text>
      )}
    </FilterRadioContainer>
  );
}
